exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".matrix_header{display:flex;flex-direction:row}.matrix_header .matrix_title{flex-grow:1;flex-shrink:1;flex-basis:0%}.matrix_header .permission_box{display:flex;flex-direction:row}@media(max-width: 700px){.matrix_header{flex-direction:column}.matrix_header .permission_box{flex-direction:column;padding:.5rem 0rem}.matrix_header .permission_box .row-tools:not(:first-of-type){padding-top:.5rem}}", ""]);

// exports
